export default __webpack_public_path__ + "static/media/H'Wear Side Left.520afd6d.jpg";